import PropTypes from "prop-types"
import React from "react"
import { getPaymentStatusBadgeProps } from "src/main/Billing/Payments/PaymentStatusBadge"

import Badge from "src/components/Badge"

import { formatDay } from "../PaymentDetail/helpers"

const InvoiceHeader = ({ invoice }) => {
  const { label, color } = getPaymentStatusBadgeProps(invoice.statusLabel)
  const details = [
    invoice.contactName,
    `Due ${formatDay(invoice.dueOn)}`,
    invoice.paidOn && `Paid ${formatDay(invoice.paidOn)}`,
  ]

  return (
    <header className="flex items-start gap-4">
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border border-gray-300">
        <i
          className="fa-solid fa-file-invoice-dollar text-2xl text-gray-700"
          aria-hidden="true"
        />
      </div>
      <div>
        <div className="flex flex-wrap items-center gap-3">
          <h1 className="m-0 text-2xl font-bold text-gray-900">
            {invoice.displaySequentialId}
          </h1>
          <Badge text={label} color={color} />
        </div>
        <p className="m-0 mt-1 text-sm text-gray-700">
          <a href={invoice.sourcePath}>{invoice.kindLabel}</a>
          {" · "}
          {details.filter(Boolean).join(" · ")}
        </p>
      </div>
    </header>
  )
}

InvoiceHeader.propTypes = {
  invoice: PropTypes.shape({
    displaySequentialId: PropTypes.string.isRequired,
    statusLabel: PropTypes.string.isRequired,
    dueOn: PropTypes.string.isRequired,
    paidOn: PropTypes.string,
    kindLabel: PropTypes.string.isRequired,
    sourcePath: PropTypes.string.isRequired,
    contactName: PropTypes.string,
  }).isRequired,
}

export default InvoiceHeader
